module.exports = __webpack_public_path__ + "static/img/wechat.3929f0b9.jpg";